import Vue from "vue";
import Router from "vue-router";
import UserApi from "@/api/UserApi";

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      name: "Login",
      path: "/login",
      component: () => import("@/views/auth/Login")
    },
    {
      path: "/admin",
      component: () => import("@/views/dashboard/admin/Index"),
      redirect: "/admin/users/user",
      children: [
        // Dashboard
        {
          name: "Dashboard",
          path: "dashboard",
          component: () => import("@/views/dashboard/admin/Dashboard")
        },
        // Dashboard
        {
          name: "User",
          path: "users/:type",
          component: () => import("@/views/dashboard/admin/Users")
        },
        {
          name: "Ca tham vấn",
          path: "booking-slots",
          component: () => import("@/views/dashboard/admin/BookingSlot")
        },
        {
          name: "Chi tiết buổi tham vấn",
          path: "booking-slots/:id",
          component: () => import("@/views/dashboard/psychology/SlotDetail")
        },
        {
          name: "Báo cáo cuộc hội thoại",
          path: "report-conversation",
          component: () => import("@/views/dashboard/admin/ReportConversation")
        },
        {
          name: "Yêu cầu hoàn tiền",
          path: "refund-requests",
          component: () => import("@/views/dashboard/admin/RefundRequest")
        },
        {
          name: "Cuộc hội thoại",
          path: "conversations/:id",
          component: () => import("@/views/dashboard/admin/ConversationDetail")
        },
        {
          name: "Cuộc hội thoại",
          path: "users/:id/conversations",
          component: () => import("@/views/dashboard/admin/Conversations")
        },
        {
          name: "Đơn đăng ký NLN-TVV",
          path: "registration-forms",
          component: () => import("@/views/dashboard/admin/RegistrationForm")
        }
      ]
    },
    {
      path: "/psychology",
      name: "Psychology",
      redirect: "/psychology/booking-slots",
      component: () => import("@/views/dashboard/psychology/Index"),
      children: [
        {
          name: "BookingSlots",
          path: "booking-slots",
          component: () => import("@/views/dashboard/psychology/BookingSlots")
        },
        {
          name: "Chi tiết buổi tham vấn",
          path: "booking-slots/:id",
          component: () => import("@/views/dashboard/psychology/SlotDetail")
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem("accessToken");
  if (to.name !== "Login" && !accessToken) next({ name: "Login" });
  else if (accessToken) {
    UserApi.profile(accessToken).then(res => {
      if (!res.ok || res.data.role === "user") {
        localStorage.removeItem("accessToken");
        next({ name: "Login" });
      }
      if (res.data.role === "admin") {
        if (!to.path.includes("admin")) {
          next({ name: "Dashboard" });
        } else next();
      }
      if (res.data.role === "psychology") {
        if (!to.path.includes("psychology")) {
          next({ name: "Psychology" });
        } else next();
      }
    });
  } else next();
});

export default router;
